import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/auth/models';
import { AuthService } from 'src/app/auth/services';
import { DataService } from 'src/app/shared/services/data.service';

import { NavigationService } from '../service/navigation.service';

@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    standalone: false
})
export class TopNavComponent implements OnInit, OnDestroy {
  @ViewChild('insideElement', { static: false })
  insideElement!: ElementRef<HTMLDivElement>;
  @ViewChild('icon', { static: false })
  profileIcon!: ElementRef<HTMLDivElement>;

  public showActions: boolean = false;
  public insideIcon: boolean = false;
  public insideActionMenu: boolean = false;
  public user: User = this.authService.userValue;
  public showRole =
    this.user && this.user?.roleClass?.roleName != 'Super_admin';
  public roleCode = this.user && this.user?.roleClass?.code;

  constructor(
    private authService: AuthService,
    public dataService: DataService,
    private router: Router,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.onDocumentClick);
  }

  public onDocumentClick(event: MouseEvent) {
    if (
      this.insideElement &&
      (this.insideElement.nativeElement.contains(<Node>event.target) ||
        this.profileIcon.nativeElement.contains(<Node>event.target))
    ) {
      return;
    }
    this.showActions = false;
  }

  signOut() {
    this.authService.logout();
  }

  resetPassword() {
    this.showActions = false;
    this.router.navigate(['/app/reset']);
  }

  leaveIcon(t: number) {
    if (this.insideIcon || this.insideActionMenu) {
      this.showActions = true;
    } else {
      setTimeout(
        (time: number) => {
          if (!this.insideIcon && !this.insideActionMenu)
            this.showActions = false;
        },
        t * 1000,
        t
      );
    }
  }

  getPermissionSettings(permissionKey: string) {
    let showSettings = false;
    if (permissionKey === 'settingAccess') {
      showSettings =
        this.user &&
        this.user?.roleClass?.permissionRef?.[permissionKey] !== 'NA';
    } else if (permissionKey === 'userAccess') {
      showSettings =
        this.user &&
        this.user?.roleClass?.permissionRef?.[permissionKey] !== 'NA';
    }
    return showSettings;
  }

  navigateSettings() {
    const navigateTo = `app/settings`;
    this.router.navigate([navigateTo]);
  }

  navigateUsers() {
    const navigateTo = `app/user`;
    this.router.navigate([navigateTo]);
  }

  navigatePermissions(){
    const navigateTo = `app/permissions`;
    this.router.navigate([navigateTo]);
  }

  navigateProfile() {
    const navigateTo = `app/my-profile`;
    this.router.navigate([navigateTo]);
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  }
}
